import { render, staticRenderFns } from "./LockHistory.vue?vue&type=template&id=21b8f3ce&scoped=true&"
import script from "./LockHistory.vue?vue&type=script&lang=js&"
export * from "./LockHistory.vue?vue&type=script&lang=js&"
import style0 from "./LockHistory.vue?vue&type=style&index=0&id=21b8f3ce&scoped=true&lang=css&"
import style1 from "./LockHistory.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b8f3ce",
  null
  
)

export default component.exports